import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SafeHtmlService } from '../services/safe-html.service';

@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer, private safeHtmlService: SafeHtmlService) {}

  public transform(content: string): SafeHtml {
    if (!content) return '';
    let sanitized = this.safeHtmlService.getSafeHtmlWithStyles(content);
    return this.sanitizer.bypassSecurityTrustHtml(sanitized);
  }
}
